import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    billing_periods_container: {
        display: 'flex',
        flexDirection: 'column',
    },
    total_due_card: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(3),
        borderRadius: 8,
        marginBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: theme.shadows[2],
    },
    total_due_label: {
        fontSize: '1.1rem',
        fontWeight: 500,
        marginBottom: theme.spacing(1),
    },
    total_due_value: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
    },
    billing_periods_table: {
        display: 'flex',
        flexDirection: 'column',
    },
    elements_container: {},
    billing_period_info_container: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: '150px 150px auto 150px 120px 50px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 12,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        alignItems: 'center',
        "&:hover": {
            backgroundColor: `${theme.palette.grey[100]}`,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.secondary.light}`,
            borderLeft: `8px solid ${theme.palette.secondary.light}`,
        }
    },
    amount_due_container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        paddingRight: theme.spacing(2),
    },
    amount_due_label: {
        fontSize: '0.75rem',
        color: theme.palette.grey[600],
    },
    amount_due_value: {
        fontSize: '1.1rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    filter_container: {
        display: "grid",
        marginTop: '16px',
        marginBottom: '16px',
        gridTemplateColumns: "repeat( auto-fit, minmax(280px, 1fr) )",
        rowGap: 16,
        columnGap: 10,
        "& button": {
            justifySelf: "end"
        }
    },
    search_btn: {
        justifySelf: 'flex-end'
    },
    status_container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
}));

export {useStyles}
